import Vue from 'vue';

export * from './name-routes';
export * from '../api/axios';
export * from './event-bus';
export * from './type-params';
export * from './type-resource';
export * from './type-colors';
import moment from 'moment';

moment.locale('es');

export const isNumber = value => {
    return !isNaN(parseFloat(value)) && isFinite(value);
};

export const getUniqueId = () => {
    let d = new Date().getTime(); //Timestamp
    let d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};


export const getRandomColor = () => {
    const red = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);
    const alpha = Math.random();
    return `rgba(${red}, ${0}, ${blue}, ${alpha})`;
};

export const convertValueToNumber = (value: string | number | null | undefined): number | null => {
    if (value == null) return null;
    if (typeof value === 'number') return value;
    const trimmed = value.trim();
    if (trimmed === '') return null;
    const num = parseFloat(trimmed);
    return Number.isFinite(num) ? num : null;
}
